/* eslint-disable jsx-a11y/media-has-caption */
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { VideoComponent } from '../../video-lazy';

/**
 * @description Render memoized in river video file media block component
 * @param {Object} props
 * @returns {JSX.Element} Memoized in river video file media block component
 */
export const InRiverVideoFileMedia = memo(function MemoizedInRiverVideoFileMedia(props) {
  const { src = '#', status } = props;
  return status === 'Published' && src ? <VideoComponent src={src} /> : null;
});

InRiverVideoFileMedia.propTypes = {
  src: PropTypes.string,
  status: PropTypes.string
};
